<p class="mat-typography">
    <mat-toolbar color="primary">
        <span>{{ appTitle }}{{ environmentSuffix }}</span>
        <span class="flex-auto"></span>
        <button mat-icon-button (click)="logout()">
            <mat-icon>logout</mat-icon>
        </button>
    </mat-toolbar>
</p>